<template>
  <div id="content-container">
    <RecordIndex :category="3"></RecordIndex>
  </div>
</template>

<script>
import RecordIndex from './index'

export default {
  components: {
    RecordIndex,
  },
}
</script>